import {
  mapActions,
  mapGetters
} from 'vuex';
import UtilisateursI18n from './Utilisateurs.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['users', 'usersLoading'])
  },

  data() {
    return {};
  },

  watch: {},

  methods: {
    ...mapActions(['getUsers', 'activeUser', 'disableUser']),

    /**
     * Fonction pour activer l'utilisateur.
     * @param {*} pUser 
     */
    activeCurrentUser(pUser) {
      this.activeUser(pUser.id).then(res => {

      }).catch(err => {
        console.log(err)
      })
    },

    /**
     * Fonction pour désactiver l'utilisateur.
     * @param {*} pUser 
     */
    disableCurrentUser(pUser) {
      this.disableUser(pUser.id).then(res => {

      }).catch(err => {
        console.log(err)
      })
    }
  },

  mounted() {
    this.getUsers().then(res => {

    }).catch(err => {
      console.log(err)
    })
  },

  i18n: UtilisateursI18n,

};